import React from "react";

const Footer = () => {
  return (
    <div className="relative bottom-0 p-5 bg-slate-800 text-white text-center font-bold">
      Made with 🤍 by Chanakyha
    </div>
  );
};

export default Footer;
